
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[tenantId]/reports/[gameId]",
      function () {
        return require("private-next-pages/[tenantId]/reports/[gameId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[tenantId]/reports/[gameId]"])
      });
    }
  